"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIProvideServices = void 0;
function isIProvideServices(value) {
    return "get" in value;
}
exports.isIProvideServices = isIProvideServices;
//# sourceMappingURL=IProvideServices.js.map